// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

function StudyCard({ sponsor, study }) {
  return (
    <div className="yt-col full s_50 m_33 l_25 study-card">
      <Link to={`/my-studies/${study.slug}`}  className="card -hoverable">
        <div className="card-header">
          <div className="title -study-name">
            <small>Program</small>
            <div>{study.name}</div>
          </div>
        </div>
        <div className="card-body">
          <p className="-summary"> {study.summary} </p>
        </div>
        <div className="card-footer">
          <div className="yt-row right">
            { sponsor ?
              <div className="-sponsor-logo">
                <img src={sponsor.logo} width="50" />
              </div>
              :
              null
            }
          </div>
        </div>
      </Link>
    </div>
  )
}

StudyCard.propTypes = {
  sponsor: PropTypes.object
  , study: PropTypes.object.isRequired
}

StudyCard.defaultProps = {
  sponsor: null
}

export default StudyCard;



// WEBPACK FOOTER //
// modules/study/components/StudyCard.js.jsx